import { toast, ToastType } from 'react-toastify';

function getToastType(type:string) {
    switch (type) {
        case 'info':
            return ToastType.INFO;
        case 'warning':
            return ToastType.WARNING;
        case 'error':
            return ToastType.ERROR;
        case 'success':
            return ToastType.SUCCESS;
        default:
            return ToastType.DEFAULT;
    }
}

export default function displayGlobalMessage(message: string, type: string) {
    // Type can be : ['info', 'success', 'error', 'warning']
    toast(message, {
        position: toast.POSITION.TOP_CENTER,
        type: getToastType(type),
        autoClose: 1700
    });
}
